import "core-js/modules/es6.reflect.construct.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _extends from "@babel/runtime/helpers/extends";
import _typeof from "@babel/runtime/helpers/typeof";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.array.map.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import Animate from '../../wui-animate/src';
import { browser, getNodeChildren, toArray, warnOnlyTreeNode } from './util';
import PropTypes from 'prop-types';
import { get } from "lodash-es";
import { KeyCode } from '../../wui-core/src';
var browserUa = typeof window !== 'undefined' ? browser(window.navigator) : '';
var ieOrEdge = /.*(IE|Edge).+/.test(browserUa); // const uaArray = browserUa.split(' ');
// const gtIE8 = uaArray.length !== 2 || uaArray[0].indexOf('IE') === -1 || Number(uaArray[1]) > 8;

var defaultTitle = '---';

var TreeNode = /*#__PURE__*/function (_React$Component) {
  _inherits(TreeNode, _React$Component);

  var _super = _createSuper(TreeNode);

  function TreeNode(_props) {
    var _this2;

    _classCallCheck(this, TreeNode);

    _this2 = _super.call(this, _props);

    _defineProperty(_assertThisInitialized(_this2), "autoExpandNode", function (props) {
      if (props.autoExpand && !props.expanded && !props.isLeaf) {
        _this2.onExpand();

        _this2.initExpand = true;
      }
    });

    _defineProperty(_assertThisInitialized(_this2), "getNodeChildren", function () {
      var children = _this2.props.children;
      var originList = toArray(children).filter(function (node) {
        return node;
      });
      var targetList = getNodeChildren(originList);

      if (originList.length !== targetList.length) {
        warnOnlyTreeNode();
      }

      return targetList;
    });

    ['onExpand', 'onCheck', 'onContextMenu', 'onMouseEnter', 'onMouseLeave', 'onDragStart', 'onDragEnter', 'onDragOver', 'onDragLeave', 'onDrop', 'onDragEnd', 'onDoubleClick', 'onKeyDown'].forEach(function (m) {
      _this2[m] = _this2[m].bind(_assertThisInitialized(_this2));
    });
    _this2.state = {
      dataLoading: false,
      dragNodeHighlight: false
    };
    _this2.initExpand = false;
    return _this2;
  }

  _createClass(TreeNode, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!get(this, ['props', 'root', '_treeNodeInstances'])) {
        if (!get(this, ['props', 'root'])) {
          this.props.root = {};
        }

        this.props.root._treeNodeInstances = [];
      }

      this.props.root._treeNodeInstances.push(this);

      this.autoExpandNode(this.props);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (!this.initExpand) {
        this.autoExpandNode(nextProps);
      }
    }
  }, {
    key: "onCheck",
    value: // shouldComponentUpdate(nextProps) {
    //   if (!nextProps.expanded) {
    //     return false;
    //   }
    //   return true;
    // }
    function onCheck(event) {
      this.props.root.onCheck(this, event);
    }
  }, {
    key: "onSelect",
    value: function onSelect() {
      clearTimeout(this.doubleClickFlag);

      var _this = this;

      if (this.props.onDoubleClick) {
        //执行延时
        this.doubleClickFlag = setTimeout(function () {
          //do function在此处写单击事件要执行的代码
          _this.props.root.onSelect(_this);
        }, 300);
      } else {
        _this.props.root.onSelect(_this);
      }
    }
  }, {
    key: "onDoubleClick",
    value: function onDoubleClick() {
      clearTimeout(this.doubleClickFlag);
      this.props.root.onDoubleClick(this);
    }
  }, {
    key: "onMouseEnter",
    value: function onMouseEnter(e) {
      e.preventDefault();
      this.props.root.onMouseEnter(e, this);
    }
  }, {
    key: "onMouseLeave",
    value: function onMouseLeave(e) {
      e.preventDefault();
      this.props.root.onMouseLeave(e, this);
    }
  }, {
    key: "onContextMenu",
    value: function onContextMenu(e) {
      e.preventDefault();
      this.props.root.onContextMenu(e, this);
    }
  }, {
    key: "onDragStart",
    value: function onDragStart(e) {
      // console.log('dragstart', this.props.eventKey, e);
      // e.preventDefault();
      e.stopPropagation();
      this.setState({
        dragNodeHighlight: true
      });
      this.props.root.onDragStart(e, this);

      try {
        // ie throw error
        // firefox-need-it
        e.dataTransfer.setData('text/plain', '');
      } finally {// empty
      }
    }
  }, {
    key: "onDragEnter",
    value: function onDragEnter(e) {
      e.preventDefault();
      e.stopPropagation();
      this.props.root.onDragEnter(e, this);
    }
  }, {
    key: "onDragOver",
    value: function onDragOver(e) {
      // todo disabled
      e.preventDefault();
      e.stopPropagation();
      this.props.root.onDragOver(e, this);
      return false;
    }
  }, {
    key: "onDragLeave",
    value: function onDragLeave(e) {
      e.stopPropagation();
      this.props.root.onDragLeave(e, this);
    }
  }, {
    key: "onDrop",
    value: function onDrop(e) {
      e.preventDefault();
      e.stopPropagation();
      this.setState({
        dragNodeHighlight: false
      });
      this.props.root.onDrop(e, this);
    }
  }, {
    key: "onDragEnd",
    value: function onDragEnd(e) {
      e.stopPropagation();
      this.setState({
        dragNodeHighlight: false
      });
      this.props.root.onDragEnd(e, this);
    }
  }, {
    key: "onExpand",
    value: function onExpand() {
      var _this3 = this;

      var callbackPromise = this.props.root.onExpand(this);

      if (callbackPromise && _typeof(callbackPromise) === 'object') {
        var setLoading = function setLoading(dataLoading) {
          _this3.setState({
            dataLoading: dataLoading
          });
        };

        setLoading(true);
        callbackPromise.then(function () {
          setLoading(false);
        }, function () {
          setLoading(false);
        });
      }
    } // keyboard event support

  }, {
    key: "onKeyDown",
    value: function onKeyDown(e) {
      this.props.root.onKeyDown(e, this);

      if (e.keyCode == KeyCode.SPACE || e.keyCode == KeyCode.DOWN || e.keyCode == KeyCode.LEFT || e.keyCode == KeyCode.RIGHT || e.keyCode == KeyCode.UP) {
        e.preventDefault();
      }
    }
  }, {
    key: "onSwitcherMouseDown",
    value: function onSwitcherMouseDown(e) {
      e.preventDefault();
    }
  }, {
    key: "onCheckboxMouseDown",
    value: function onCheckboxMouseDown(e) {
      e.preventDefault();
    }
  }, {
    key: "renderSwitcher",
    value: function renderSwitcher(props, expandedState) {
      var stateIcon;
      var clsPrefix = props.clsPrefix;

      var switcherCls = _defineProperty({}, "".concat(clsPrefix, "-switcher"), true);

      if (!props.showLine) {
        switcherCls["".concat(clsPrefix, "-noline_").concat(expandedState)] = true;
      } else if (props.pos === '0-0') {
        switcherCls["".concat(clsPrefix, "-roots_").concat(expandedState)] = true;
      } else {
        switcherCls["".concat(clsPrefix, "-center_").concat(expandedState)] = !props.last;
        switcherCls["".concat(clsPrefix, "-bottom_").concat(expandedState)] = props.last;
      }

      if (expandedState === 'open' && props.openIcon) {
        stateIcon = props.openIcon;
        switcherCls['icon-none'] = true;
      }

      if (expandedState === 'close' && props.closeIcon) {
        stateIcon = props.closeIcon;
        switcherCls['icon-none'] = true;
      } //switcherCls[stateIcon] = stateIcon;


      props.switcherClass ? switcherCls["".concat(props.switcherClass)] = true : '';

      if (props.disabled && !props.mustExpandable) {
        switcherCls["".concat(clsPrefix, "-switcher-disabled")] = true;
        return /*#__PURE__*/React.createElement("span", {
          className: classNames(switcherCls),
          style: props.switcherStyle
        }, stateIcon);
      }

      return /*#__PURE__*/React.createElement("span", {
        className: classNames(switcherCls),
        style: props.switcherStyle,
        onMouseDown: this.onSwitcherMouseDown,
        onClick: this.onExpand
      }, stateIcon);
    }
  }, {
    key: "renderCheckbox",
    value: function renderCheckbox(props) {
      var clsPrefix = props.clsPrefix;

      var checkboxCls = _defineProperty({}, "".concat(clsPrefix, "-checkbox"), true);

      if (props.checked) {
        checkboxCls["".concat(clsPrefix, "-checkbox-checked")] = true;
      } else if (props.halfChecked) {
        checkboxCls["".concat(clsPrefix, "-checkbox-indeterminate")] = true;
      }

      var customEle = null;

      if (typeof props.checkable !== 'boolean') {
        customEle = props.checkable;
      }

      if (props.disabled || props.disableCheckbox) {
        checkboxCls["".concat(clsPrefix, "-checkbox-disabled")] = true;
        return /*#__PURE__*/React.createElement("span", {
          className: classNames(checkboxCls)
        }, customEle);
      }

      return /*#__PURE__*/React.createElement("span", {
        className: classNames(checkboxCls),
        onClick: this.onCheck,
        onMouseDown: this.onCheckboxMouseDown
      }, customEle);
    }
  }, {
    key: "renderChildren",
    value: function renderChildren(props) {
      var renderFirst = this.renderFirst;
      this.renderFirst = 1;
      var transitionAppear = true;

      if (!renderFirst && props.expanded) {
        transitionAppear = false;
      }

      var children = props.children && Array.isArray(props.children) ? props.children.filter(function (child) {
        return child;
      }) : props.children;
      var newChildren = children; // 确定所有子节点是否是TreeNode

      var allTreeNode = false;

      if (Array.isArray(children)) {
        for (var index = 0; index < children.length; index++) {
          var item = children[index];
          if (!item) break;
          allTreeNode = item.type.isTreeNode == 1;

          if (!allTreeNode) {
            //当检查到子节点中有不是 TreeNode 的，则直接结束检查。同时不会渲染所有子节点
            break;
          }
        }
      } else if (children && children.type && children.type.isTreeNode == 1) {
        allTreeNode = true;
      } //  如果props.children的长度大于0才可以生成子对象


      if (allTreeNode && React.Children.count(children)) {
        var _cls;

        var cls = (_cls = {}, _defineProperty(_cls, "".concat(props.clsPrefix, "-child-tree"), true), _defineProperty(_cls, "".concat(props.clsPrefix, "-child-tree-open"), props.expanded), _cls);

        if (props.showLine) {
          cls["".concat(props.clsPrefix, "-line")] = !props.last;
        }

        var animProps = {};

        if (props.openTransitionName) {
          animProps.transitionName = props.openTransitionName;
        } else if (_typeof(props.openAnimation) === 'object') {
          animProps.animation = Object.assign({}, props.openAnimation);

          if (!transitionAppear) {
            delete animProps.animation.appear;
          }
        }

        newChildren = /*#__PURE__*/React.createElement(Animate, _extends({}, animProps, {
          showProp: "data-expanded",
          transitionAppear: transitionAppear,
          component: ""
        }), !props.expanded ? null : /*#__PURE__*/React.createElement("ul", {
          className: classNames(cls),
          "data-expanded": props.expanded
        }, React.Children.map(children, function (item, index) {
          return props.root.renderTreeNode(item, index, props.pos);
        }, props.root)));
      }

      return newChildren;
    }
  }, {
    key: "checkIsLeaf",
    value:
    /**
     *判断是否为叶子节点，isLeaf的优先级>props.children。如果是异步加载是根据isLeaf的值进行判断的
     *
     * @returns
     * @memberof TreeNode
     */
    function checkIsLeaf() {
      var _this$props = this.props,
          isLeaf = _this$props.isLeaf,
          loadData = _this$props.loadData;
      var rs = isLeaf;

      if (rs === false || rs === true) {
        return rs;
      } else {
        var hasChildren = this.getNodeChildren().length !== 0;
        return !loadData && !hasChildren;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _iconEleCls,
          _this4 = this;

      var props = this.props;
      var clsPrefix = props.clsPrefix;
      var expandedState = props.expanded ? 'open' : 'close';
      var iconState = expandedState;
      var canRenderSwitcher = true;
      var content = props.title;
      var newChildren = this.renderChildren(props);
      var openIconCls = false,
          closeIconCls = false; //以下变量控制是否鼠标单机双击方法中的变量

      var timer = 0;
      var delay = 500;
      var prevent = false; // if (!newChildren || newChildren === props.children) {
      //   // content = newChildren;
      //   newChildren = null;
      //   if (!props.loadData || props.isLeaf) {
      //     canRenderSwitcher = false;
      //     iconState = 'docu';
      //   }
      // }

      if (this.checkIsLeaf()) {
        canRenderSwitcher = false;
        iconState = 'docu';
      } // For performance, does't render children into dom when `!props.expanded` (move to Animate)
      // if (!props.expanded) {
      //   newChildren = null;
      // }


      var iconEleCls = (_iconEleCls = {}, _defineProperty(_iconEleCls, "".concat(clsPrefix, "-iconEle"), true), _defineProperty(_iconEleCls, "".concat(clsPrefix, "-icon_loading"), this.state.dataLoading), _defineProperty(_iconEleCls, "".concat(clsPrefix, "-icon__").concat(iconState), true), _iconEleCls);

      var selectHandle = function selectHandle() {
        var titleClass = props.titleClass ? clsPrefix + '-title' + ' ' + props.className : clsPrefix + '-title'; // const icon = (props.showIcon || props.loadData && this.state.dataLoading) ?
        //   <span className={classNames(iconEleCls)}></span> : null;

        var icon;

        if (props.showIcon && props.icon) {
          icon = /*#__PURE__*/React.createElement("span", {
            className: classNames("".concat(clsPrefix, "-iconEle"), "".concat(clsPrefix, "-icon__customize"))
          }, typeof currentIcon === 'function' ? /*#__PURE__*/React.createElement(props.icon, _objectSpread({}, _this4.props)) : props.icon);
        } else if (props.showIcon || props.loadData && _this4.state.dataLoading) {
          icon = /*#__PURE__*/React.createElement("span", {
            className: classNames(iconEleCls)
          });
        }

        var title = /*#__PURE__*/React.createElement("span", {
          className: titleClass,
          style: props.titleStyle
        }, content);
        var wrap = "".concat(clsPrefix, "-node-content-wrapper");
        var domProps = {
          className: "".concat(wrap, " ").concat(wrap, "-").concat(iconState === expandedState ? iconState : 'normal')
        };

        if (!props.disabled) {
          if (props.selected || !props._dropTrigger && _this4.state.dragNodeHighlight) {
            domProps.className += " ".concat(clsPrefix, "-node-selected");
          }

          domProps.onClick = function (e) {
            var _this = _this4;
            e.preventDefault();

            if (props.selectable) {
              _this.onSelect();
            } // not fire check event
            // if (props.checkable) {
            //   this.onCheck();
            // }

          };

          if (props.onDoubleClick) {
            domProps.onDoubleClick = _this4.onDoubleClick;
          }

          if (props.onRightClick) {
            domProps.onContextMenu = _this4.onContextMenu;
          }

          if (props.onMouseEnter) {
            domProps.onMouseEnter = _this4.onMouseEnter;
          }

          if (props.onMouseLeave) {
            domProps.onMouseLeave = _this4.onMouseLeave;
          }

          if (props.draggable) {
            domProps.className += ' draggable';

            if (ieOrEdge) {
              // ie bug!
              domProps.href = '#';
            }

            domProps.draggable = true;
            domProps['aria-grabbed'] = true;
            domProps.onDragStart = _this4.onDragStart;
          }
        } //设置tabIndex


        if (props.focusable) {
          domProps.onKeyDown = _this4.onKeyDown;
          domProps.tabIndex = -1;

          if (props.tabIndexKey) {
            if (props.eventKey == props.tabIndexKey) {
              domProps.tabIndex = props.tabIndexValue;
            }
          } else if (props.pos == '0-0') {
            domProps.tabIndex = props.tabIndexValue;
          }
        }

        return /*#__PURE__*/React.createElement("a", _extends({
          ref: function ref(el) {
            _this4.selectHandle = el;
          },
          pos: props.pos,
          title: typeof content === 'string' ? content : ''
        }, domProps), icon, title);
      };

      var liProps = {};

      if (props.liAttr) {
        liProps = Object.assign({}, props.liAttr);
      }

      if (props.draggable) {
        liProps.onDragEnter = this.onDragEnter;
        liProps.onDragOver = this.onDragOver;
        liProps.onDragLeave = this.onDragLeave;
        liProps.onDrop = this.onDrop;
        liProps.onDragEnd = this.onDragEnd;
      }

      var disabledCls = '';
      var dragOverCls = '';

      if (props.disabled) {
        disabledCls = "".concat(clsPrefix, "-treenode-disabled");
      } else if (props.dragOver) {
        dragOverCls = 'drag-over';
      } else if (props.dragOverGapTop) {
        dragOverCls = 'drag-over-gap-top';
      } else if (props.dragOverGapBottom) {
        dragOverCls = 'drag-over-gap-bottom';
      }

      var filterCls = props.filterTreeNode ? props.filterTreeNode(this) ? 'filter-node' : '' : '';

      var noopSwitcher = function noopSwitcher() {
        var _cls2;

        var cls = (_cls2 = {}, _defineProperty(_cls2, "".concat(clsPrefix, "-switcher"), true), _defineProperty(_cls2, "".concat(clsPrefix, "-switcher-noop"), true), _cls2);

        if (props.showLine) {
          // console.log('line---------');
          cls["".concat(clsPrefix, "-center_docu")] = !props.last;
          cls["".concat(clsPrefix, "-bottom_docu")] = props.last;
        } else {
          cls["".concat(clsPrefix, "-noline_docu")] = true;
        }

        return /*#__PURE__*/React.createElement("span", {
          className: classNames(cls)
        });
      };

      var selectedCls = props.selected ? "".concat(clsPrefix, "-treenode-selected") : '';
      var focusedCls = props.focused ? "".concat(clsPrefix, "-treenode-focused") : '';
      var expandedCls = "".concat(clsPrefix, "-treenode-").concat(expandedState);
      return /*#__PURE__*/React.createElement("li", _extends({}, liProps, {
        style: props.style,
        className: classNames(props.className, disabledCls, dragOverCls, filterCls, selectedCls, focusedCls, expandedCls)
      }), canRenderSwitcher ? this.renderSwitcher(props, expandedState) : noopSwitcher(), props.checkable ? this.renderCheckbox(props) : null, selectHandle(), newChildren);
    }
  }]);

  return TreeNode;
}(React.Component);

TreeNode.isTreeNode = 1;
TreeNode.propTypes = {
  clsPrefix: PropTypes.string,
  disabled: PropTypes.bool,
  disableCheckbox: PropTypes.bool,
  expanded: PropTypes.bool,
  isLeaf: PropTypes.bool,
  root: PropTypes.object,
  onSelect: PropTypes.func,
  openIcon: PropTypes.element,
  closeIcon: PropTypes.element,
  style: PropTypes.object,
  className: PropTypes.string,
  titleClass: PropTypes.string,
  titleStyle: PropTypes.object,
  switcherClass: PropTypes.string,
  switcherStyle: PropTypes.object
};
TreeNode.defaultProps = {
  title: defaultTitle,
  tabIndexValue: 0,
  mustExpandable: false
};
export default TreeNode;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-tree/src/TreeNode.js